/* src/app/events/event-notifications/event-notification-header/event-notification-header.component.scss */
:host {
  text-transform: lowercase;
}
.specific-time {
  margin-left: auto;
  margin-right: 20%;
}
/*# sourceMappingURL=event-notification-header.component.css.map */
